<template>
	<v-dialog v-model="isVisible" max-width="400">
		<p-card class="tw-p-none verbs-loading-template-dialog overflow-hidden">
			<p-header-dialog
				search
				:negative-margin="false"
				@closeClicked="close()"
				@on-search="filterJobs">
				Plantillas de Puesto
			</p-header-dialog>
			<ul class="tw-p-none verbs-loading-template-dialog--list tw-text-app-color-font">
				<li v-for="(jobs, index) in (jobTemplateList.length && jobTemplateFiltered.length === 0 ? jobTemplateList : jobTemplateFiltered)" :key="index"
					class="tw-flex tw-justify-between tw-items-center tw-gap-4 tw-px-4 tw-py-2">
					<span class="tw-inline-block">{{ index + 1 }}.</span>
					<div class="tw-flex-1"> {{ jobs.job.name }}</div>
					<app-tooltip-button
						img="/static/img/pdf.svg"
						text="PDF"
						@click-icon="viewPDF(jobs)"
					/>
					<p-button
						size="small"
						type="primary"
						:outlined="true"
						@click="selectedTemplate(jobs)">Seleccionar
					</p-button>
				</li>
			</ul>
			<p-empty-message style="height: 50vh" v-if="!jobTemplateList.length">
				No hay plantillas disponibles
			</p-empty-message>
		</p-card>
	</v-dialog>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PEmptyMessage from '@/modules/shared/components/ui/p-empty-message';
import PButton from '@/modules/shared/components/ui/p-button';
import PHeaderDialog from '@/modules/job-profile/components/content/p-header-dialog';
import { path } from 'ramda';
import { mapState } from 'vuex';

function created() {
	this.loadJobs();
}

async function loadJobs() {
	try {
		const { data: response } = await this.$httpPraktiko.get('job-description/true');
		this.jobTemplateList = response;
	} catch (error) {
		this.showGenericError();
	}
}

async function selectedTemplate(job) {
	const body = {
		additionalInformation: job.additionalInformation,
		steps: job.steps,
		jobId: this.selectedJob.id,
		code: 'job-profile',
	};
	try {
		await this.$httpPraktiko.post('job-description/clone', body);
		this.showNotification('Plantilla cargada Correctamente');
		this.$emit('reload', true);
		this.close();
	} catch (error) {
		this.showGenericError();
	}
}

function filterJobs(filter) {
	this.jobTemplateFiltered = this.jobTemplateList.filter(job => job.job.name.toLowerCase()
		.includes(filter.toLowerCase()));
}

function viewPDF(jobTemplate) {
	window.open(jobTemplate.urlFile, '_blank');
}

export default {
	name: 'verbs-loading-template-dialog',
	components: {
		PCard,
		PHeaderDialog,
		PEmptyMessage,
		PButton,
	},
	created,
	data() {
		return {
			isVisible: false,
			templates: [],
			selectedOptions: {},
			jobTemplateFiltered: [],
			jobTemplateList: [],
		};
	},
	props: {
	},
	methods: {
		loadJobs,
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
		selectedTemplate,
		filterJobs,
		viewPDF,
	},
	computed: {
		// ...mapState('jobEvaluation', {
		// 	jobTemplateList: pathOr([], ['supplies', 'guidelineModel', 'userForm', 'jobList']),
		// }),
		...mapState('jobProfile', {
			selectedJob:
				path(['selectedJob']),
		}),
	},
	watch: {
	},
};
</script>

<style lang="scss" scoped>
.verbs-loading-template-dialog {
	&--list {
		padding: 0;
		height: 50vh;
		overflow: auto;
		li {
			border-bottom: 1px solid var(--app-color-gray);
		}
	}	
}
</style>


// WEBPACK FOOTER //
// src/modules/job-profile/components/first-step/verbs-loading-template-dialog.vue